import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shopaddress',
  templateUrl: './shopaddress.component.html',
  styleUrls: ['./shopaddress.component.css']
})
export class ShopaddressComponent implements OnInit {

  pageName = "Shop Address";

  constructor() { }

  ngOnInit() {
  }

}
